export default __webpack_public_path__ + "static/media/Table Management.6fc23a52.jpg";